import { Theme } from '@mui/material';

export default function Button(theme: Theme) {
    return {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            },
            styleOverrides: {
                root: {
                    textTransform: 'none'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: 'TT Commons Pro',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: '20px',
                    borderRadius: '100px',
                    height: theme.spacing(5),
                    padding: theme.spacing(1, 4),
                    backgroundColor: theme.palette.semantic.int.selected,
                    color: theme.palette.semantic.text.inverse,
                    boxShadow: 'none',
                    '&:hover': {
                        backgroundColor: theme.palette.semantic.int.selected,
                        color: theme.palette.semantic.text.inverse
                    },
                    '&.Mui-disabled': {
                        backgroundColor: theme.palette.neutral[100],
                        color: theme.palette.neutral[300],
                        cursor: 'not-allowed'
                    }
                },
                text: {
                    backgroundColor: 'transparent',
                    color: theme.palette.primary[500],
                    textDecoration: 'underline',
                    textUnderlineOffset: '4px',
                    padding: theme.spacing(1, 0),
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: theme.palette.primary[500],
                        textDecoration: 'underline',
                        textUnderlineOffset: '4px'
                    },
                    '&:active': {
                        backgroundColor: 'transparent',
                        color: theme.palette.primary[700],
                        textDecoration: 'underline',
                        textUnderlineOffset: '4px'
                    }
                },
                containedInherit: {
                    color: theme.palette.neutral[800],
                    borderRadius: theme.spacing(6),
                    '&:hover': {
                        backgroundColor: theme.palette.neutral.white
                    }
                },
                outlinedInherit: {
                    border: `1px solid ${theme.palette.neutral[500]}`,
                    borderRadius: theme.spacing(6),
                    '&:hover': {
                        backgroundColor: theme.palette.neutral[50] // Assuming hover color
                    }
                },
                containedPrimary: {
                    boxShadow: 'none'
                },
                outlinedPrimary: {
                    backgroundColor: theme.palette.semantic.bg.default,
                    color: theme.palette.semantic.int.selected,
                    border: `1px solid ${theme.palette.semantic.int.selected}`,
                    '&:hover': {
                        color: theme.palette.semantic.int.selected,
                        backgroundColor: theme.palette.semantic.bg.default,
                        border: `1px solid ${theme.palette.semantic.int.selected}`
                    }
                },
                containedSecondary: {
                    //variant='contained', color='secondary' for rectangle button
                    borderRadius: 0,
                    width: '-webkit-fill-available;'
                },
                outlinedSecondary: {
                    backgroundColor: theme.palette.neutral.white,
                    color: theme.palette.secondary[700],
                    border: `1px solid ${theme.palette.secondary[700]}`,
                    '&:hover': {
                        backgroundColor: theme.palette.secondary[500],
                        color: theme.palette.neutral.white,
                        border: `1px solid ${theme.palette.secondary[500]}`
                    }
                },
                sizeLarge: {
                    height: theme.spacing(6)
                },
                sizeSmall: {
                    fontSize: '14px',
                    lineHeight: '16px',
                    height: theme.spacing(1),
                    fontWeight: 500,
                    '&.MuiButton-text': {
                        padding: theme.spacing(0, 0.25)
                    }
                }
            }
        }
    };
}
